// this file contains the logic from the old "app/assets/javascripts/company/company.js"
/* global Swiper */
import { initAccordions, requireCountryCode } from '../helpers/util'

const removeVideo = () => {
  document.querySelector('.js-modal-content').innerHTML = "";
  document.removeEventListener("afd-modal:close", removeVideo);
}

const updateModalContent = templateId => {
  const template = document.getElementById(templateId);
  const content = template.content.cloneNode(true);

  const modalContent = document.querySelector('.js-modal-content');
  modalContent.innerHTML = "";
  modalContent.append(content);
  document.addEventListener("afd-modal:close", removeVideo);
}

function initToggleButtons () {
  var toggleBtns = document.querySelectorAll('[data-toggle]');
  Array.from(toggleBtns).forEach(function (btn) {
    const { target, toggle, postToggle } = btn.dataset;
    const targetEl = target ? document.querySelector(target) : null;
    if (!targetEl || !toggle) return;

    if (toggle === 'collapse') {
      const visibleItems = +btn.dataset['visibleItems'];
      if (targetEl.children.length <= visibleItems) {
        btn.style.display = 'none';
      }
      Array.from(targetEl.children).forEach((el, idx) => {
        if (idx >= visibleItems) {
          el.classList.add('collapsible');
        }
      })
    }

    btn.addEventListener('click', function (e) {
      switch (toggle) {
        case 'collapse':
          targetEl.classList.toggle('collapsed');
          break;
        case 'modal':
          const { modalContent } = btn.dataset;
          if(modalContent) updateModalContent(modalContent);
          AFD.modals.open('#' + targetEl.id)
          break;
      }
      const { altText } = btn.dataset;
      if (altText) {
        btn.dataset['altText'] = btn.innerText;
        btn.innerText = altText;
      }
      if (postToggle && postToggle === 'destroy') {
        btn.style.display = 'none';
      }
    })
  });
}

function acordeonOneClick(){
  var $category = $('.acordeon__category');
  var companyId = $category.data('company-id');
  var sales = 'sales';
  var branches = 'branches';
  var category = 'account-contact-metrics';

  $category.one('click', function(){
    if($(this).hasClass(sales)) window.adInsights.e(category, 'click', 'sales-contact', companyId);
    if($(this).hasClass(branches)) window.adInsights.e(category, 'click', 'branches', companyId);
  });
}

// Initialize BIM manufacturers carousel
function initializeBIMManufacturersCarousel() {
  var manufacturers = new Swiper('.bim-manufacturers', {
    slidesPerView: 4,
    spaceBetween: 20,
    navigation: {
      nextEl: '.bim-manufacturers__arrow-next',
      prevEl: '.bim-manufacturers__arrow-prev',
    },
    pagination: {
      el: '.bim-manufacturers__bullets',
      dynamicBullets: true,
    },
    breakpoints: {
      767: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: true
      }
    }
  });
}

window.onload = acordeonOneClick();

/**
 * Information such as address and phone is hidden at first
 * They only display after being clicked
 */
const companyContactInfoHandler = () => {
  const placeholders = document.querySelectorAll('.companies-info__btn-placeholder')
  placeholders.forEach(el => {
    const realInfo = el.nextElementSibling
    el.addEventListener('click', () => {
      el.style.display = 'none'
      realInfo.classList.remove('companies-info__btn')
    })
  })
}

const initCompanyProductsLoadMore = () => {
  const button = document.querySelector('.js-company-products-load-more')
  const productList = document.querySelector('#products-list')
  if (!button || !productList) return

  button.addEventListener('click', async () => {
    if (!button.dataset.url || button.disabled) return

    button.disabled = true
    button.setAttribute('aria-busy', 'true')

    try {
      const response = await fetch(button.dataset.url, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
      if (!response.ok) throw new Error(`Unable to load company products: ${response.status}`)

      const data = await response.json()
      productList.insertAdjacentHTML('beforeend', data.html)

      if (data.next_url) {
        button.dataset.url = data.next_url
        button.disabled = false
        button.removeAttribute('aria-busy')
      } else {
        button.remove()
      }
    } catch (error) {
      button.disabled = false
      button.removeAttribute('aria-busy')
      button.dataset.loadError = error.message
    }
  })
}

const initCompanyLinkedResources = () => {
  const container = document.querySelector('.js-company-linked-resources')
  const menuMarker = document.querySelector('.js-company-linked-resources-menu-marker')
  if (!container || container.dataset.pending !== 'true') return

  let attempts = 0
  const maxAttempts = 5

  const loadLinkedResources = async () => {
    attempts += 1

    try {
      const url = new URL(container.dataset.url, window.location.origin)
      if (attempts === maxAttempts) url.searchParams.set('force_refresh', 'true')

      const response = await fetch(url.toString(), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
      if (!response.ok) throw new Error(`Unable to load linked resources: ${response.status}`)

      const data = await response.json()
      if (!data.pending) {
        container.innerHTML = data.html
        document.querySelectorAll('.js-company-linked-resource-menu-item').forEach(item => item.remove())
        if (menuMarker) menuMarker.insertAdjacentHTML('beforebegin', data.menu_html)
        container.dataset.pending = 'false'
        return
      }
    } catch (error) {
      container.dataset.loadError = error.message
    }

    if (attempts < maxAttempts) window.setTimeout(loadLinkedResources, 1500)
  }

  loadLinkedResources()
}

const trackCompanySocialInteraction = (link, callback) => {
  if (!link || !window.dataLayer || typeof window.dataLayer.push !== 'function') {
    if (typeof callback === 'function') callback()
    return
  }

  let callbackCalled = false
  const finish = () => {
    if (callbackCalled) return
    callbackCalled = true
    if (typeof callback === 'function') callback()
  }

  window.dataLayer.push({
    event: 'custom_event',
    type: 'click',
    internalType: 'onclick',
    eventCallback: finish,
    dimensions: {
      category: 'company',
      action: '1817,company,click',
      label: 'Company page interaction',
      dim1: link.dataset.companyInteractionId || '',
      dim2: link.dataset.companyInteractionLang || '',
      dim3: link.dataset.companyInteractionType || '',
      dim4: link.dataset.companyInteractionPlatform || '',
      dim5: null,
      dim6: null,
      dim7: null,
      dim8: null,
      dim9: null,
      dim10: null
    }
  })

  window.setTimeout(finish, 250)
}

const initCompanySocialTracking = () => {
  document.querySelectorAll('.js-company-social-tracking').forEach(link => {
    link.addEventListener('click', event => {
      if (
        event.defaultPrevented ||
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey
      ) return

      event.preventDefault()

      const href = link.getAttribute('href')
      const target = link.getAttribute('target') || '_self'
      trackCompanySocialInteraction(link, () => {
        if (!href) return

        if (target === '_blank') {
          window.open(href, '_blank', 'noopener')
          return
        }

        window.location.assign(href)
      })
    }, true)
  })
}

const interpolate = (template, values = {}) => {
  if (!template) return ''

  return template.replace(/%\{(\w+)\}/g, (_match, key) => values[key] || '')
}

const companyAvailabilityVariant = props => {
  const countryCode = window.AFD && window.AFD.countryCode

  if (!countryCode) return props.langMismatch ? props.copy.langMismatch : null

  const businessCountries = props.businessCountries || []
  const siblingTargets = props.siblingTargets || []
  const location = (window.NFT && window.NFT.countries && window.NFT.countries[countryCode]) || countryCode
  const userInBusinessCountries = businessCountries.includes(countryCode)
  const siblingForCountry = siblingTargets.find(target => (target.business_countries || []).includes(countryCode))
  const siblingForLang = siblingTargets.find(target => target.lang === props.selectedLang)
  const siblingAvailableInCountry = !!siblingForCountry

  if (userInBusinessCountries) {
    return props.langMismatch ? props.copy.langMismatch : null
  }

  if (props.langMismatch && siblingAvailableInCountry) {
    return {
      heading: props.copy.langMismatchGeoWithSibling.heading,
      message: interpolate(props.copy.langMismatchGeoWithSibling.message, {
        sibling_url: (siblingForCountry || siblingForLang || {}).url
      })
    }
  }

  if (props.langMismatch) {
    return props.copy.langMismatchGeoNoSibling
  }

  if (siblingAvailableInCountry) {
    return {
      heading: interpolate(props.copy.geoWithSibling.heading, { location }),
      message: interpolate(props.copy.geoWithSibling.message, {
        sibling_url: (siblingForCountry || siblingForLang || {}).url
      })
    }
  }

  return {
    heading: interpolate(props.copy.geoNoSibling.heading, { location })
  }
}

const initCompanyAvailabilityToaster = () => {
  const toasterWrapper = document.querySelector('.js-company-availability-toaster')
  const toaster = toasterWrapper && toasterWrapper.querySelector('hd-toaster')
  if (!toasterWrapper || !toaster) return

  const props = JSON.parse(toasterWrapper.dataset.props || '{}')

  const renderToaster = () => {
    const variant = companyAvailabilityVariant(props)

    if (!variant || !variant.heading) {
      toaster.removeAttribute('heading')
      toaster.removeAttribute('message-html')
      toasterWrapper.classList.add('afd-hide')
      return
    }

    toaster.setAttribute('heading', variant.heading)

    if (variant.message) {
      toaster.setAttribute('message-html', variant.message)
    } else {
      toaster.removeAttribute('message-html')
    }

    toasterWrapper.classList.remove('afd-hide')
  }

  renderToaster()
  requireCountryCode(renderToaster)
}

export const initCompanyPage = () => {
  const companyPage = document.querySelector('#companies-wrap, .companies-show, .companies-bim_files, .companies-account_files')
  if (!companyPage) return

  initCompanyAvailabilityToaster()
  initToggleButtons()
  initCompanyProductsLoadMore()
  initCompanyLinkedResources()
  initCompanySocialTracking()
  companyContactInfoHandler()
  initAccordions()

  const contactButton = document.querySelector('.account-info-request-btn')
  if (document.body.contains(contactButton)) {
    contactButton.addEventListener('click', function (e) {
      e.preventDefault();
      AFD.modals.open('#modal-account-info-request')
    });
  }

  initializeBIMManufacturersCarousel()
};
